export const STRIPE_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
// Stripe.js v8+ automatically uses the API version associated with the library version
// The apiVersion and betas parameters are no longer supported
export const STRIPE_CONFIG = {
  developerTools: {
    assistant: {
      enabled: false
    }
  }
};

export const PAYMENT_METHOD_CARD = "card";
export const PAYMENT_METHOD_APPLE = "apple-pay";
